module.exports = __webpack_public_path__ + "static/media/Ajay p shaji.e91de4f3.jpg";